// extracted by mini-css-extract-plugin
export default {"content":"loader_content__MjGsu","backdrop":"loader_backdrop__bzPzL"};